import { createSelector } from 'reselect';

import isOneLineAddressScreen from '~/src/features/full-buy/helpers/ab/isOneLineAddressScreen';
import { ESteps } from '~/src/features/full-buy/types';
import { TState } from '~/src/store';

const getStep = (state: TState) => state.fullBuy.stepIndex;
const getFlow = (state: TState) => state.fullBuy.flow;

const getStepForNextButton = (isVillage = false) => createSelector(
    [getStep, getFlow],
    (stepIndex, flow) => {
        const isOneLineAddressFormScreen = isOneLineAddressScreen() || isVillage;
        let _step = String(flow?.steps[stepIndex]);

        if (_step === ESteps.address) {
            _step = `${_step}_${Number(isOneLineAddressFormScreen)}`;
        }

        return _step;
    },
);

export default getStepForNextButton;
